import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const createEventPackage = createAsyncThunk("createEventPackage", async (data) => {
    const response = await API.post('event-package/create', data);
    return response.data;
});

export const updateEventPackage = createAsyncThunk("updateEventPackage", async (data) => {
    const response = await API.put('event-package/edit', data);
    return response.data;
});

export const eventPackagesListAction = createAsyncThunk("eventPackagesListAction", async ({ page, limit }) => {
    const response = await API.get('event-package/list', {
        params: { page, limit }
    });
    return response.data;
});

export const eventPackagesAllAction = createAsyncThunk("eventPackagesAllAction", async () => {
    const response = await API.get('event-package/all');
    return response.data;
});

export const deleteEventPackage = createAsyncThunk("deleteEventPackage", async ({ id }) => {
    const response = await API.delete('event-package/delete', {
        params: { id }
    });
    return response.data;
});
